import script from "./AccPayModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccPayModal.vue?vue&type=script&setup=true&lang=ts"

import "./AccPayModal.vue?vue&type=style&index=0&id=42caa74a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42caa74a"]])

export default __exports__